<template>
    <ErrorTemplate v-bind="{ statusCode, statusMessage, description, stack }" />
</template>

<script setup>
import { MiscError404, MiscError500, MiscErrorDev } from '#components'
import {definePageMeta} from "#imports";

const props = defineProps({
    // eslint-disable-next-line vue/require-default-prop
    error: Object
})

const stacktrace = (props.error.stack || '')
    .split('\n')
    .splice(1)
    .map((line) => {
        const text = line
            .replace('webpack:/', '')
            .replace('.vue', '.js')
            .trim()
        return {
            text,
            internal: (line.includes('node_modules') && !line.includes('.cache')) ||
                line.includes('internal') ||
                line.includes('new Promise')
        }
    }).map(i => `<span class="stack${i.internal ? ' internal' : ''}">${i.text}</span>`).join('\n')

// Error page props
const statusCode = String(props.error.statusCode || 500)
const is404 = statusCode === '404'

const statusMessage = props.error.statusMessage ?? (is404 ? 'Page Not Found' : 'Internal Server Error')
const description = props.error.message || props.error.toString()
const stack = import.meta.dev ? props.error.description || `<pre>${stacktrace}</pre>` : undefined
const ErrorTemplate = is404 ? MiscError404 : import.meta.dev ? MiscErrorDev : MiscError500
</script>
